function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1467",
    style: {
      fill: "#007008",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 48.763173,229.34158 c 0,5.23311 -9.474552,28.23669 -9.474552,28.23669 0,0 -9.474553,-23.00358 -9.474553,-28.23669 0,-5.2324 4.242153,-9.4742 9.474553,-9.4742 5.233104,0 9.474552,4.2418 9.474552,9.4742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1469",
    style: {
      fill: "#007008",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.022061,230.9125 c 3.700286,3.69993 13.26656,26.66577 13.26656,26.66577 0,0 -22.965127,-9.56628 -26.66506,-13.26657 -3.6999338,-3.69993 -3.6999338,-9.69927 0,-13.3992 3.699933,-3.69993 9.698566,-3.69993 13.3985,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1471",
    style: {
      fill: "#007008",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 11.052641,248.10336 c 5.232753,0 28.23598,9.47491 28.23598,9.47491 0,0 -23.003227,9.47384 -28.23598,9.47384 -5.2323998,0 -9.4745528,-4.24144 -9.4745528,-9.47384 0,-5.23311 4.242153,-9.47491 9.4745528,-9.47491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1473",
    style: {
      fill: "#007008",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 12.623561,270.84377 c 3.699933,-3.69994 26.66506,-13.2655 26.66506,-13.2655 0,0 -9.566274,22.96477 -13.266208,26.66506 -3.700286,3.69993 -9.698919,3.69993 -13.398852,0 -3.6999338,-3.70029 -3.6999338,-9.69892 0,-13.39956"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1475",
    style: {
      fill: "#007008",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 29.814068,285.81354 c 0,-5.2324 9.474553,-28.23527 9.474553,-28.23527 0,0 9.474552,23.00287 9.474552,28.23527 0,5.2331 -4.241448,9.47455 -9.474552,9.47455 -5.2324,0 -9.474553,-4.24145 -9.474553,-9.47455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1477",
    style: {
      fill: "#007008",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 52.55483,284.24333 c -3.699934,-3.70029 -13.266209,-26.66506 -13.266209,-26.66506 0,0 22.965479,9.56556 26.665764,13.2655 3.699934,3.69993 3.699934,9.69927 0,13.39956 -3.700285,3.69993 -9.69927,3.69993 -13.399555,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1479",
    style: {
      fill: "#007008",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 67.5246,267.05211 c -5.2324,0 -28.235979,-9.47384 -28.235979,-9.47384 0,0 23.003579,-9.47491 28.235979,-9.47491 5.232752,0 9.474552,4.2418 9.474552,9.4742 0,5.23311 -4.2418,9.47455 -9.474552,9.47455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1481",
    style: {
      fill: "#007008",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 65.954385,244.3117 c -3.700285,3.70029 -26.665764,13.26657 -26.665764,13.26657 0,0 9.566275,-22.96584 13.266209,-26.66577 3.700285,-3.69993 9.698918,-3.69993 13.399555,0 3.699934,3.69993 3.699934,9.69927 0,13.3992"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1483",
    style: {
      fill: "#9f4f1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.387192,250.62678 c 1.919465,-4.45488 4.715581,-10.59321 6.144331,-12.05371 1.1684,-1.19486 2.716035,-1.79458 4.265084,-1.79458 1.504595,0 3.010603,0.56585 4.171243,1.70074 2.35585,2.3047 2.397832,6.08189 0.09419,8.43703 -0.582435,0.59549 -1.93675,1.4351 -3.636079,2.35797 1.38571,-1.77976 1.28552,-4.35363 -0.328083,-6.02156 -0.902759,-0.93275 -2.104322,-1.40194 -3.307647,-1.40194 -1.151818,0 -2.305401,0.43003 -3.198635,1.29399 -0.95391,0.92286 -2.727677,4.38502 -4.204406,7.48206"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1485",
    style: {
      fill: "#9f4f1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.269673,249.76001 c -1.792816,-4.50674 -4.15431,-10.82076 -4.17689,-12.86264 -0.03634,-3.29494 2.604559,-5.99545 5.899857,-6.0325 0.02222,-3.4e-4 0.04516,-3.4e-4 0.06738,-3.4e-4 3.264252,0 5.928077,2.62714 5.964412,5.90056 0.0092,0.83256 -0.354541,2.38372 -0.903462,4.23721 -0.279048,-2.23766 -2.168879,-3.98744 -4.48945,-4.0259 -0.02611,-3.4e-4 -0.05186,-7.1e-4 -0.07761,-7.1e-4 -2.505778,0 -4.557535,2.01048 -4.599868,4.52508 -0.02222,1.3268 1.170517,5.02603 2.315633,8.25924"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1487",
    style: {
      fill: "#9f4f1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 32.342425,253.48181 c -4.455228,-1.91946 -10.597795,-4.7177 -12.058295,-6.14645 -2.356203,-2.30434 -2.39783,-6.08083 -0.09384,-8.43632 1.168753,-1.19522 2.716742,-1.79494 4.265789,-1.79494 1.50495,0 3.010606,0.56586 4.171244,1.7011 0.595135,0.58208 1.4351,1.93675 2.357615,3.63537 -0.826558,-0.64347 -1.823863,-0.96661 -2.822575,-0.96661 -1.15182,0 -2.305051,0.43004 -3.198637,1.29434 -1.82633,1.76671 -1.874661,4.67995 -0.10795,6.50663 0.92322,0.95427 4.388556,2.72945 7.486648,4.20688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1489",
    style: {
      fill: "#9f4f1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 18.539997,263.7741 c -3.264253,0 -5.927725,-2.62784 -5.964061,-5.8995 -0.03669,-3.29494 2.604558,-5.99581 5.899502,-6.0325 0.01023,0 0.02082,-2.7e-4 0.03105,-2.7e-4 0.839964,0 2.375958,0.36195 4.206522,0.90382 -2.238022,0.27905 -3.987094,2.16958 -4.025547,4.48945 -0.04198,2.54106 1.982964,4.63515 4.524022,4.67783 0.01235,0 0.02434,2.7e-4 0.03704,2.7e-4 1.357841,0 5.022144,-1.18287 8.227128,-2.3181 -4.507087,1.79281 -10.824984,4.15607 -12.86792,4.17865 -0.02258,2.6e-4 -0.04516,2.6e-4 -0.06773,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1491",
    style: {
      fill: "#9f4f1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 24.780636,278.37698 c -1.504598,0 -3.010606,-0.5655 -4.171245,-1.70074 -2.35585,-2.30399 -2.39783,-6.08118 -0.09384,-8.43668 0.582436,-0.59549 1.936397,-1.4351 3.635728,-2.35761 -1.385006,1.77941 -1.285522,4.35328 0.328083,6.02086 0.902759,0.93309 2.10432,1.40193 3.307645,1.40193 1.151818,0 2.30505,-0.42968 3.198635,-1.29363 0.953912,-0.92287 2.727324,-4.38432 4.204053,-7.48136 -1.919113,4.45488 -4.715228,10.59286 -6.143272,12.05301 -1.168752,1.19486 -2.716741,1.79422 -4.265788,1.79422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1493",
    style: {
      fill: "#9f4f1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.517221,284.29095 c -3.264254,0 -5.928079,-2.62713 -5.964414,-5.8995 -0.0092,-0.83291 0.354893,-2.38478 0.903816,-4.23863 0.278694,2.23802 2.169232,3.9878 4.48945,4.02626 0.02612,7.9e-4 0.05186,7.9e-4 0.07761,7.9e-4 2.506134,0 4.55789,-2.01013 4.599872,-4.52473 0.02222,-1.32574 -1.169459,-5.02179 -2.314223,-8.25394 1.792816,4.50638 4.152548,10.81687 4.174773,12.85804 0.03704,3.29495 -2.604559,5.9944 -5.89915,6.03145 -0.02257,2.6e-4 -0.04516,2.6e-4 -0.06773,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1495",
    style: {
      fill: "#9f4f1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 54.120808,278.05172 c -1.504595,0 -3.010251,-0.5655 -4.170537,-1.70039 -0.595489,-0.58243 -1.4351,-1.93675 -2.357614,-3.63537 0.826558,0.64276 1.82386,0.96555 2.822575,0.96555 1.151818,0 2.305401,-0.43003 3.198283,-1.29434 1.826329,-1.76636 1.875367,-4.6796 0.108656,-6.50628 -0.921104,-0.9525 -4.371975,-2.72097 -7.464779,-4.19629 4.453115,1.91876 10.57769,4.70923 12.035718,6.13586 2.356205,2.30399 2.39748,6.08118 0.09349,8.43633 -1.1684,1.19486 -2.716741,1.79493 -4.26579,1.79493"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1497",
    style: {
      fill: "#9f4f1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 60.070407,263.31373 c -0.839613,0 -2.375959,-0.3616 -4.206524,-0.90382 2.238375,-0.27869 3.987449,-2.16958 4.026252,-4.4891 0.04163,-2.54141 -1.983668,-4.63514 -4.524727,-4.67783 -0.01199,-2.6e-4 -0.02434,-2.6e-4 -0.03669,-2.6e-4 -1.356429,0 -5.017556,1.18145 -8.220779,2.31598 4.506735,-1.79281 10.819693,-4.15431 12.86157,-4.17689 0.02222,0 0.04516,-2.6e-4 0.06738,-2.6e-4 3.264606,0 5.928077,2.62784 5.96406,5.90056 0.03669,3.29424 -2.603852,5.99511 -5.89915,6.03144 -0.01024,2.7e-4 -0.02082,2.7e-4 -0.03139,2.7e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1499",
    style: {
      fill: "#6b541d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.326721,255.28909 c 0,0 -1.008591,-2.56893 -2.057048,-5.52908 1.100315,2.76507 1.98614,4.84998 1.98614,4.84998 0,0 3.242027,-8.12588 4.865158,-13.60769 0.02646,0.21307 0.03845,0.43039 0.03492,0.65122 -0.04233,2.54106 -4.829175,13.63557 -4.829175,13.63557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1501",
    style: {
      fill: "#663517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.255813,254.60999 c 0,0 -0.885825,-2.08491 -1.98614,-4.84998 -1.145116,-3.23321 -2.337858,-6.93244 -2.315633,-8.25924 0.04233,-2.5146 2.09409,-4.52508 4.599868,-4.52508 0.02574,0 0.05151,3.4e-4 0.07761,7.2e-4 2.320571,0.0385 4.210402,1.78823 4.48945,4.0259 C 42.497837,246.48412 39.25581,254.61 39.25581,254.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1503",
    style: {
      fill: "#6b541d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.696888,255.9322 c 0,0 -2.523773,-1.10102 -5.354463,-2.45039 2.728738,1.17546 4.823883,2.02106 4.823883,2.02106 v 0 0 c 0,0 -3.452987,-8.03839 -6.181369,-13.0623 0.169333,0.13194 0.33161,0.27728 0.485419,0.43603 1.766713,1.82669 6.22653,13.0556 6.22653,13.0556"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1505",
    style: {
      fill: "#663517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.166308,255.50287 c 0,0 -2.095145,-0.8456 -4.823883,-2.02106 -3.098092,-1.47743 -6.563428,-3.25261 -7.486648,-4.20688 -1.766711,-1.82668 -1.71838,-4.73992 0.10795,-6.50663 0.893586,-0.8643 2.046817,-1.29434 3.198637,-1.29434 0.998712,0 1.996017,0.32314 2.822575,0.96661 2.728382,5.02391 6.181369,13.0623 6.181369,13.0623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1507",
    style: {
      fill: "#6b541d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.47565,259.5951 c 2.76225,-1.09926 4.844698,-1.98403 4.844698,-1.98403 0,0 -8.12553,-3.24202 -13.607343,-4.86551 0.187678,-0.0233 0.378883,-0.0353 0.572558,-0.0353 0.02646,0 0.05256,2.7e-4 0.07902,8e-4 2.541058,0.042 13.63486,4.82847 13.63486,4.82847 0,0 -2.566106,1.00753 -5.523796,2.05563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1509",
    style: {
      fill: "#663517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.248522,261.9132 c -0.0127,0 -0.02469,-2.7e-4 -0.03704,-2.7e-4 -2.541058,-0.0427 -4.566003,-2.13677 -4.524022,-4.67783 0.03845,-2.31987 1.787525,-4.2104 4.025547,-4.48945 5.481813,1.62348 13.607343,4.86551 13.607343,4.86551 0,0 -2.082448,0.88477 -4.844698,1.98402 -3.204984,1.13524 -6.869287,2.31811 -8.227128,2.31811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1511",
    style: {
      fill: "#6b541d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 24.15128,265.88195 c 0.131939,-0.16969 0.277283,-0.33197 0.436033,-0.48542 1.826684,-1.76742 13.055952,-6.22724 13.055952,-6.22724 0,0 -1.102783,2.52766 -2.453569,5.36046 1.176512,-2.73085 2.023534,-4.82953 2.023534,-4.82953 0,0 -8.037689,3.45335 -13.06195,6.18173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1513",
    style: {
      fill: "#663517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 27.787008,273.30474 c -1.203325,0 -2.404886,-0.46884 -3.307645,-1.40193 -1.613605,-1.66758 -1.713089,-4.24145 -0.328083,-6.02086 5.024261,-2.72838 13.06195,-6.18173 13.06195,-6.18173 0,0 -0.847022,2.09868 -2.023534,4.82953 -1.476729,3.09704 -3.250141,6.55849 -4.204053,7.48136 -0.893585,0.86395 -2.046817,1.29363 -3.198635,1.29363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1515",
    style: {
      fill: "#6b541d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.456623,274.15282 c -0.02646,-0.21308 -0.0381,-0.43003 -0.03457,-0.65087 0.04198,-2.54106 4.828471,-13.63486 4.828471,-13.63486 0,0 1.010002,2.5721 2.058811,5.53402 -1.101019,-2.76754 -1.98755,-4.85457 -1.98755,-4.85457 0,0 -3.241675,8.12447 -4.865159,13.60628"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1517",
    style: {
      fill: "#663517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.023683,278.17978 c -0.02574,0 -0.0515,0 -0.07761,-7.9e-4 -2.320218,-0.0385 -4.210756,-1.78823 -4.48945,-4.02625 1.623484,-5.48182 4.865159,-13.60629 4.865159,-13.60629 0,0 0.886531,2.08703 1.98755,4.85458 1.144764,3.23215 2.336448,6.9282 2.314223,8.25394 -0.04198,2.5146 -2.093738,4.52472 -4.599872,4.52472"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1519",
    style: {
      fill: "#6b541d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.592657,272.71596 c -0.169686,-0.13194 -0.331965,-0.27728 -0.485775,-0.43603 -1.766711,-1.82739 -6.226527,-13.05631 -6.226527,-13.05631 0,0 2.537528,1.10666 5.377037,2.46098 -2.739671,-1.18004 -4.846812,-2.03024 -4.846812,-2.03024 0,0 3.453693,8.03769 6.182077,13.0616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1521",
    style: {
      fill: "#663517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.415232,273.68151 c -0.998715,0 -1.996017,-0.32279 -2.822575,-0.96555 -2.728384,-5.02391 -6.182077,-13.0616 -6.182077,-13.0616 0,0 2.107141,0.8502 4.846812,2.03024 3.092804,1.47532 6.543675,3.24379 7.464779,4.19629 1.766711,1.82668 1.717673,4.73992 -0.108656,6.50628 -0.892882,0.86431 -2.046465,1.29434 -3.198283,1.29434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1523",
    style: {
      fill: "#6b541d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 55.291325,262.44554 c -0.02611,0 -0.05257,-2.6e-4 -0.07867,-7.9e-4 -2.541411,-0.0419 -13.634861,-4.82874 -13.634861,-4.82874 0,0 2.569634,-1.00859 5.530144,-2.0574 -2.765777,1.10032 -4.851048,1.98649 -4.851048,1.98649 0,0 8.125179,3.24168 13.606991,4.86481 -0.187676,0.0233 -0.378883,0.0356 -0.572558,0.0356"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1525",
    style: {
      fill: "#663517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 55.863883,262.40991 c -5.481812,-1.62313 -13.606991,-4.86481 -13.606991,-4.86481 0,0 2.085271,-0.88617 4.851048,-1.98649 3.203223,-1.13453 6.86435,-2.31598 8.220779,-2.31598 0.01236,0 0.02468,0 0.03669,2.6e-4 2.541059,0.0427 4.566357,2.13642 4.524727,4.67783 -0.0388,2.31952 -1.787877,4.21041 -4.026252,4.4891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1527",
    style: {
      fill: "#6b541d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 40.934682,255.98583 c 0,0 1.102076,-2.52695 2.45251,-5.35905 -1.176512,2.7312 -2.023179,4.82918 -2.023179,4.82918 0,0 8.037687,-3.45335 13.06195,-6.18173 -0.13194,0.16933 -0.277283,0.33161 -0.435681,0.48507 -1.826684,1.76706 -13.0556,6.22653 -13.0556,6.22653"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1529",
    style: {
      fill: "#663517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.364013,255.45596 c 0,0 0.846667,-2.09798 2.023179,-4.82918 1.476729,-3.09704 3.250496,-6.5592 4.204406,-7.48206 0.893234,-0.86396 2.046817,-1.29399 3.198635,-1.29399 1.203325,0 2.404888,0.46919 3.307647,1.40194 1.613603,1.66793 1.713793,4.2418 0.328083,6.02156 -5.024263,2.72838 -13.06195,6.18173 -13.06195,6.18173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1531",
    style: {
      fill: "#343017",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.660242,258.19139 c 0,2.679 -2.1717,4.8507 -4.850694,4.8507 -2.678641,0 -4.850693,-2.1717 -4.850693,-4.8507 0,-2.67899 2.172052,-4.85069 4.850693,-4.85069 2.678994,0 4.850694,2.1717 4.850694,4.85069"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower10);
export default __webpack_public_path__ + "static/media/flower-10.1d1a91f4a4c1f9be91b1fd06240adbe0.svg";
export { ForwardRef as ReactComponent };